import { forwardRef } from 'react';
import { Plus } from 'lucide-react';
import { Button, createPolymorphicComponent, em, Tooltip, type ButtonProps } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

const C = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ leftSection = <Plus />, children = 'Tambah', ...props }, ref) => {
    const isMobile = useMediaQuery(`(max-width: ${em(750)})`);

    if (isMobile) {
      return (
        <Tooltip label="Tambah">
          <Button ref={ref} {...props} h={36} w={36} p={0}>
            <Plus />
          </Button>
        </Tooltip>
      );
    }

    return (
      <Tooltip label="Tambah">
        <Button leftSection={leftSection} ref={ref} {...props}>
          {children}
        </Button>
      </Tooltip>
    );
  }
);

C.displayName = 'CreateButton';

export const CreateButton = createPolymorphicComponent<'button', ButtonProps>(C);
